package com.yendo.mx.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CuponFirebase(
    val activo: Boolean = false,
    val aplicaDelivery: Boolean = false,
    val aplicaPickup: Boolean = false,
    val codigo: String = "",
    val consumoMinimo: Double = 0.0,
    val idRestauranteExclusivo: String = "",
    val idZonaExclusiva: String = "",
    val metodosValidos: List<String> = emptyList(),
    val quienPaga: String = "",
    val soloPrimerPedido: Boolean = false,
    val tipo: String = "",
    val valor: Double = 0.0,
    val modulosValidos: List<String> = emptyList(), // 🚀 NUEVA VARIABLE

    // ==========================================
    // 🚀 NUEVAS VARIABLES DE SEGURIDAD Y LÍMITES
    // ==========================================

    // Límite total de veces que se puede usar este cupón en toda la app
    @SerialName("limite_usos_global")
    val limiteUsosGlobal: Int = 999999,

    // Contador en tiempo real de cuántas veces se ha usado
    @SerialName("usos_actuales")
    val usosActuales: Int = 0,

    // ¿Cuántas veces puede usarlo la misma persona? (Por defecto 1)
    @SerialName("limite_por_usuario")
    val limitePorUsuario: Int = 1
)